const messages = {
  name: 'User Management |||| User Management',
  fields: {
    scopesPerAccount: 'Permissions per account',
    name: 'Name',
    surname: 'Surname',
    email: 'Email',
    phone: 'Phone',
    telegramChatId: 'Telegram chat ID',
    scopes: 'Access to',
    aiCapabilities: 'AI',
    canUseContactCenterAi: 'Can use AI in contact center',
    canEditKnowledgeBase: 'Can edit knowledge base',
    status: 'Status',
    accounts: 'Accounts',
    notifyStaff: 'Roommatik contact-center staff',
    notifyStaffHelp: 'Can read and write the internal shift log, the one the hotel never sees. This is an SSO role, not an account permission: the hotel cannot grant it.',
    account: 'Account',
    role: 'Role',
    password: 'Password',
    confirmPassword: 'Confirm New Password',
    newPassword: 'New Password',
  },
  columns: {
    actions: 'Actions',
  },
  filters: {
    name: 'Name',
    surname: 'Surname',
    email: 'Email',
    role: 'Role',
    allRoles: 'All Roles',
  },
  scopes: {
    portal: 'Portal',
    'contact-center': 'Connect',
    'contact-center-config': 'Configure Connect',
    'knowledge-base': 'Knowledge base',
    'automations': 'Flow',
    'manage-users': 'Manage users',
    app: 'App',
  },
  capabilities: {
    ai: 'AI',
    kb: 'KB',
  },
  status: {
    active: 'Active',
    blocked: 'Blocked',
  },
  deleteHard: {
    title: 'Permanently delete %{email}?',
    content: 'Their SSO identity is removed (access to every account is lost) and their record deleted. This is NOT reversible. To just stop them signing in, use Block.',
  },
  actions: {
    addUser: 'Add User',
    block: 'Block (cannot sign in; keeps accounts)',
    unblock: 'Unblock',
    deleteHard: 'Delete permanently',
    changePassword: 'Change Password',
  },
  roles: {
    superUser: 'SuperUser',
    maintenance: 'Maintenance',
    accountUser: 'Account User',
  },
  dialog: {
    userDetails: 'User Details',
    changePassword: 'Change Password',
  },
  validation: {
    emailRequired: 'Email is required',
    emailInvalid: 'Enter a valid email address',
    roleRequired: 'Role is required',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 12 characters',
    passwordPattern:
      'Password must have at least one uppercase letter, one lowercase letter, one number, and one special character',
    confirmPasswordRequired: 'Please confirm the password',
    confirmPasswordMismatch: 'Passwords do not match',
  },
  help: {
    scopesEditedInAccount: 'Edited in Accounts → Users: that is the only place that knows what each account has contracted.',
    noAccounts: 'This user does not belong to any account.',
    noScopes: 'No permissions',
    passwordPolicy:
      'At least 12 characters, with an uppercase, a lowercase, a number and a symbol.',
  },
  notifications: {
    blocked: 'User blocked.',
    unblocked: 'User unblocked.',
    deletedHard: 'User permanently deleted.',
    created: 'User created successfully',
    updated: 'User updated successfully',
    createFailed: 'Failed to create user',
    updateFailed: 'Failed to update user',
    loadUserFailed: 'Failed to load user details',
    passwordReset: 'Password updated successfully',
    passwordResetFailed: 'Failed to update password',
  },
};

export default messages;
